import { MockProvider } from './MockProvider';
import { TottusProvider } from './TottusProvider';

export const DefaultProvider = process.env.NODE_ENV === 'test' || process.env.VUE_APP_USE_MOCK ? new MockProvider() : new TottusProvider();
